<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>菜单权限管理</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="space-20">
      <a-button type="primary" @click="showModel = 'addMainMenu'">添加菜单</a-button>
      <!-- <a-button class="gap-10" type="primary">批量删除</a-button> -->
      <!-- <a-button class="gap-10" type="primary">刷新</a-button> -->
    </div>
    <a-table :loading="loading" :indentSize="10" :columns="columns" :dataSource="menuList" :rowKey="row => row.id">
      <span slot="status" slot-scope="status">{{ MENU_STATUS(status) }}</span>
      <span slot="type" slot-scope="row">{{ MENU_TYPE(row.type) }}{{ ACTION_LABELS[row.value] ? `-${ACTION_LABELS[row.value]}` : null }}</span>
      <span slot="action" slot-scope="row">
        <a-button
          :disabled="row.level >= 4 && row.type == 1"
          @click="
            menuInfo.parentId = row.id;
            showModel = 'addMainMenu';
          "
          type="primary"
          size="small"
          >添加子页面</a-button
        >
        <a-divider type="vertical" />
        <a-button
          @click="
            currentRow = row;
            showModel = 'editMenu';
          "
          size="small"
          >编辑</a-button
        >
        <a-divider type="vertical" />
        <a-button @click="handleDeleteMenu(row)" type="danger" size="small">删除</a-button>
      </span>
    </a-table>
    <a-modal :title="menuInfo.parentId === 0 ? '添加主菜单' : '添加子页面'" @cancel="closeModel" :visible="showModel == 'addMainMenu'" width="700px">
      <a-form>
        <a-form-item label="名称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="menuInfo.name" placeholder="权限(菜单)名称"></a-input>
        </a-form-item>
        <a-form-item label="文件路径：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="menuInfo.filePath" placeholder="页面路由对应views的.vue文件路径"></a-input>
        </a-form-item>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="路径：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input v-model="menuInfo.fullPath" placeholder="路由"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="requestURl：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input v-model="menuInfo.backPath" placeholder="数据接口"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="param：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input v-model="menuInfo.param" placeholder="路由参数的字段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="value：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-select v-if="menuInfo.type == 1" v-model="menuInfo.value" placeholder="请选择操作类型">
                <a-select-option v-for="v in ACTION_TYPES" :value="v.value" :key="v.value">{{ v.title }}</a-select-option>
              </a-select>
              <a-input v-else v-model="menuInfo.value" placeholder="路由参数的值"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="状态：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-radio-group v-model="menuInfo.status">
                <a-radio :value="0">正常</a-radio>
                <a-radio :value="-1">冻结</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="类型：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" help="内页：不渲染到左侧栏和头部导航">
              <a-radio-group v-model="menuInfo.type">
                <a-radio :value="0">页面</a-radio>
                <a-radio :value="1">操作</a-radio>
                <a-radio :value="2">内页</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="排序：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input-number v-model="menuInfo.sortOrder" style="width:100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="icon：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input v-model="menuInfo.icon" placeholder="icon图标" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleMenuAction('add')">确定</a-button>
      </template>
    </a-modal>
    <a-modal title="编辑信息" @cancel="closeModel" :visible="showModel == 'editMenu'" width="700px">
      <a-form>
        <a-form-item label="名称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="currentRow.name" placeholder="权限(菜单)名称"></a-input>
        </a-form-item>
        <a-form-item label="文件路径：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="currentRow.filePath" placeholder="页面路由对应views的.vue文件路径"></a-input>
        </a-form-item>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="路径：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input v-model="currentRow.fullPath" placeholder="路由"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="requestURL：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input v-model="currentRow.backPath" placeholder="数据接口"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="param：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input v-model="currentRow.param" placeholder="路由参数的字段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="value：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-select v-if="currentRow.type == 1" v-model="currentRow.value" placeholder="请选择操作类型">
                <a-select-option v-for="v in ACTION_TYPES" :value="v.value" :key="v.value">{{ v.title }}</a-select-option>
              </a-select>
              <a-input v-else v-model="currentRow.value" placeholder="路由参数的值"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="状态：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-radio-group v-model="currentRow.status">
                <a-radio :value="0">正常</a-radio>
                <a-radio :value="-1">冻结</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="类型：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" help="内页：不渲染到左侧栏和头部导航">
              <a-radio-group v-model="currentRow.type">
                <a-radio :value="0">页面</a-radio>
                <a-radio :value="1">操作</a-radio>
                <a-radio :value="2">内页</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="排序：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input-number style="width:100%" v-model="currentRow.sortOrder" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="icon：" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input v-model="currentRow.icon" placeholder="icon图标" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleMenuAction('edit')">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { menuList, menuDelete, menuAction } from '@/api/systemMenuSetting.js';
import { MENU_STATUS, MENU_TYPE, ACTION_TYPES, ACTION_LABELS } from '@/const/common.js';
const columns = [
  { title: '名称', dataIndex: 'name' },
  { title: '路径', dataIndex: 'fullPath' },
  { title: '状态', dataIndex: 'status', align: 'center', scopedSlots: { customRender: 'status' } },
  { title: '类型', align: 'center', scopedSlots: { customRender: 'type' } },
  { title: '排序', dataIndex: 'sortOrder', align: 'center' },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'action' } }
];
export default {
  data() {
    return {
      ACTION_TYPES,
      ACTION_LABELS,
      showModel: '',
      menuList: [],
      columns,
      currentRow: {},
      loading: true,
      menuInfo: {
        name: '',
        status: 0,
        type: 0,
        sortOrder: 0,
        filePath: '',
        fullPath: '',
        param: '',
        value: undefined,
        icon: '',
        parentId: 0,
        backPath: ''
      }
    };
  },
  methods: {
    MENU_STATUS,
    MENU_TYPE,
    closeModel() {
      this.showModel = '';
    },
    getMenuList() {
      this.loading = true;
      menuList().then(res => {
        this.menuList = res.data;
        this.loading = false;
      });
    },
    handleDeleteMenu(row) {
      this.$confirm({
        title: `确定删除${this.MENU_TYPE(row.type)}：${row.name}`,
        content: '直接删除，无法恢复',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          menuDelete({ permissionId: row.id }).then(res => {
            if (res.code === 200) {
              this.$message.success(res.data);
              this.getMenuList();
            }
          });
        }
      });
    },
    handleMenuAction(type) {
      let data = null;
      if (type === 'edit') {
        data = {
          id: this.currentRow.id,
          name: this.currentRow.name,
          status: this.currentRow.status,
          type: this.currentRow.type,
          sortOrder: this.currentRow.sortOrder,
          filePath: this.currentRow.filePath,
          fullPath: this.currentRow.fullPath,
          icon: this.currentRow.icon,
          parentId: this.currentRow.parentId,
          param: this.currentRow.param,
          value: this.currentRow.value,
          backPath: this.currentRow.backPath
        };
      } else if (type === 'add') {
        data = Object.assign({}, this.menuInfo);
      }
      menuAction(data).then(res => {
        if (res.code === 200) {
          this.closeModel();
          this.getMenuList();
          this.$message.success('success');
          type === 'add' &&
            (this.menuInfo = {
              name: '',
              status: 0,
              type: 0,
              sortOrder: 0,
              filePath: '',
              fullPath: '',
              icon: '',
              parentId: 0
            });
        }
      });
    }
  },
  mounted() {
    this.getMenuList();
  }
};
</script>
